import { IFieldErrors } from "src/types";
import { ValidationError } from "src/types";

export const processResponse = (response: any) => {
  const status = response.status || 200;
  if (status !== 200) {
    const message = response.message || 'Unknown error occurred';
    throw new Error(message);
  }
  // Not exception
  return response;
};

/**
 * Old logic will probably be revived in a similar fashion
 */
// if (response.errorType) {
//   if (response.errorType === 'ZodError') {
//     const result = JSON.parse(response.errorMessage);
//     let message = '';
//     for (const issue of result) {
//       const fields = issue.path || [];
//       if (fields.length > 0) {
//         for (const field of fields) {
//           message += `${field}: ${issue.message}`;
//         }
//       } else {
//         throw new Error("No fields are specified in validation response, malformed payload.");
//       }
//     }
//     throw new Error(`Validation Error: ${message}`);
//   } else if (response.errorType === 'ValidationError') {
//     const errors: IFieldErrors = JSON.parse(response.errorMessage);
//     throw new ValidationError(errors);
//   } else {
//     throw new Error(`${response.errorType}: ${response.errorMessage}`);
//   }
// }